enum HolidayTypeEnum {
    LEISURE = 'LEISURE',
    AS_REQUESTED = 'AS_REQUESTED',
    OCCASIONAL = 'OCCASIONAL',
    FREE = 'FREE',
    TRAINING = 'TRAINING'
}

export default HolidayTypeEnum;
